/*eslint-disable @typescript-eslint/no-var-requires*/
import React from 'react';
import { BrowserRouter, Redirect, Switch } from 'react-router-dom';
import { isMeetLinksProfile, isPassportProfile } from '../app-config';
import { LayoutConfig } from '../config';
import { RoutesConfig } from '../config/routes';
import Layout from '../components/_base/Layout';
import { useEventPublicInfo } from '../hooks/api/public/use-event-public-details';
import { REGISTRATION_PATH, ROOT } from '../config/routes/paths';
import { useRoutes } from '../hooks/use-custom-routes';
import { IAuthContext, useAuth } from '../lib/context-providers/auth-context';
import { getCurrentPathName, getUrlQueryArgByKey } from '../lib/api/utils';
import { IDP_IDENTIFIER, ML_ACCESS_TOKEN } from '../lib/constants';

const { Route } = (() => {
  if (isPassportProfile()) return require('../config/overrides/route');
  if (isMeetLinksProfile()) return require('react-router-dom');
})();

type Props = {
  routes: RoutesConfig
}

const RegistrationFormRoute = () => {
  const { data } = useEventPublicInfo();
  const auth = useAuth() as IAuthContext;
  const token = getUrlQueryArgByKey(ML_ACCESS_TOKEN) || '';
  const idpIdentifier = getUrlQueryArgByKey(IDP_IDENTIFIER) || '';
  const pathname = getCurrentPathName();
  const isRedirectedToRegistration = isPassportProfile() && auth?.isAuthenticated === false && !token && !idpIdentifier && !pathname && data && data.registrationAsLandingPage;
  if (auth?.ssoError) {
    return <Redirect to={ROOT}/>;
  }
  if (isRedirectedToRegistration) {
    return <Redirect to={REGISTRATION_PATH}/>;
  }
  return null;
};

const PassportAppRouter: React.FC<Props> = (props: Props): JSX.Element => {
  const customRoutes = useRoutes();

  const routes = { ...customRoutes };

  return (
    <BrowserRouter>
      <Layout {...LayoutConfig} routesConfig={routes}>
        <RegistrationFormRoute/>
        <Switch>
          {Object.keys(routes).map(path => <Route key={path} {...{ path, ...routes[path] }} />)}
        </Switch>
      </Layout>
    </BrowserRouter>
  );
};

const MeetLinksAppRouter: React.FC<Props> = ({ routes }: Props): JSX.Element => {
  return (
    <BrowserRouter>
      <Layout {...LayoutConfig} routesConfig={routes}>
        <Switch>
          {Object.keys(routes).map(path => <Route key={path} {...{ path, ...routes[path] }} />)}
        </Switch>
      </Layout>
    </BrowserRouter>
  );
};

export default isPassportProfile() ? PassportAppRouter : MeetLinksAppRouter;
